<template>
  <transition name="modal-fade">
    <div class="modal is-active">
      <div
        class="modal-background"
        @click="close"/>
      <div class="modal-content">
        <slot/>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="close"/>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import "~@/sass/variables";

$distance: -24px;

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .5s ease
}

.loader, .loading {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
}

.loader {
  width: 1.5em;
  height: 1.5em;
  margin-left: -0.75rem;
  margin-top: -0.75rem;
}

.loading {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
}

.ball {
  width: 12px;
  height: 12px;
  background: #ddd;
  border-radius: 50%;
  margin: 5px;
  animation-name: jump;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
}

@keyframes jump {
  50% {
    transform: translateY($distance);
  }
}

.ball1 {
  animation-delay: 0.1s;
}

.ball2 {
  animation-delay: 0.2s;
}

.ball3 {
  animation-delay: 0.3s;
}

.modal-content {
  background: #000;
  max-height: calc(100vh - 120px);

  .movie-details {
    padding: 20px;
  }

  .movie-info {
    display: flex;
    flex-direction: column;

    @include from(500px) {
      flex-direction: row;

      .movie-poster {
        width: 50%;
        flex-grow: 0;
        flex-shrink: 0;
      }
    }

    .movie-details-title {
      color: #a0a2a3;
      font-weight: bold;
      text-transform: uppercase;
      margin-top: 1rem;
      margin-bottom: 0.5rem;
      font-size: 1.25rem;
    }

    .movie-title {
      font-weight: bold;
      color: #fff;
      font-size: 2rem;
      line-height: 1;
      margin: 0.5rem 0;
    }

    .movie-meta {
      display: flex;
      color: #fff;
      font-weight: bold;
      font-size: 1rem;
      align-items: center;
      margin-top: 0.5rem;

      @include from(960px) {
        margin-top: 0.75rem;
      }

      span {
        margin-right: 5px;
      }

      .maturity-rating {
        height: 2em;
        display: inline-flex;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
        line-height: 1.5;
        padding-left: 0.75em;
        padding-right: 0.75em;
        white-space: nowrap;
        border: solid 1px rgba(255,255,255,.4);
      }
    }

    .movie-showtimes {
      p {
        color: #fff;
        margin-bottom: 0.5rem;

        strong {
          color: #fff;
        }
      }
    }

    .movie-poster {
      .image {
        width: 50%;
        margin: 0.5rem auto;

        @include from(500px) {
          width: 80%;
          margin-top: 1rem;
        }
      }
    }
  }

  .movie-more-info {
    .movie-details-title {
      color: #a0a2a3;
      font-weight: bold;
      text-transform: uppercase;
      margin-top: 1rem;
      margin-bottom: 0.5rem;
      font-size: 1.25rem;
    }

    p {
      color: #fff;
      margin-bottom: 0.5rem;
      text-align: justify;

      strong {
        color: #fff;
      }
    }

    .movie-media {
      .image{
        margin-bottom: 1rem;
      }
    }
  }
}

.trailer {
  background: #000;
  position: relative;
  display: block;
  padding-bottom: 56.25%;

  iframe {
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
  }
}
</style>

